module.exports = __webpack_public_path__ + "img/fa-solid-900.e5f20c3.svg";